import { ScoopButton, ScoopSelector } from '../../../../ui'
import { TargetColumnResult } from '../TargetColumnResult/TargetColumnResult'
import { EVENTS, trackEvent } from '../../../../../events'
import styles from './TargetColumn.module.scss'

export const TargetColumn = ({ mlResults, selectedInbox, analyze, mlConfig, setMlConfig }) => {
    function setTarget(targetColumn) {
        mlConfig.targetColumn = targetColumn
        if (!mlConfig.selectedFields.includes(targetColumn)) {
            mlConfig.selectedFields.push(targetColumn)
        }
        setMlConfig({ ...mlConfig })
    }

    const hasColumns = selectedInbox?.tables?.[0]?.columns?.length > 0

    return (
        <>
            {!mlResults && (
                <div className={styles.container}>
                    <p className={styles.description}>
                        This machine learning analysis will attempt to find relationships between a
                        target column and any other columns in your dataset. Pick a column in your
                        dataset to analyze. Scoop will then use machine learning modeling to attempt
                        to find relationships in the data that appear to be driving that target
                        column.
                    </p>
                    {hasColumns ? (
                        <ScoopSelector
                            label="Select a target column to explore"
                            value={mlConfig.targetColumn}
                            onChange={(e) => setTarget(e.target.value)}
                            options={
                                selectedInbox?.tables?.[0]?.columns?.map((col) => ({
                                    label: col.columnName,
                                    value: col.columnName,
                                })) || []
                            }
                            size="sm"
                            labelClassName="selector-label-bold"
                        />
                    ) : (
                        <p className={styles.noColumnsWarning}>
                            No columns available in the selected dataset. Please select a dataset
                            with data.
                        </p>
                    )}
                </div>
            )}
            <TargetColumnResult mlResults={mlResults} />
            {!mlResults && hasColumns && (
                <ScoopButton
                    onClick={() => {
                        let jsonBody = {
                            action: 'analyzeColumn',
                            targetColumn: mlConfig.targetColumn,
                        }
                        trackEvent(EVENTS.DATA_SCIENCE.ID_COLUMN, { column: mlConfig.targetColumn })
                        analyze(jsonBody)
                    }}
                    disabled={!mlConfig.targetColumn}
                    variant="default"
                >
                    Analyze
                </ScoopButton>
            )}
        </>
    )
}
